import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createSharePercentService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.sharePercent, payload)).data;
};

export const getSharePercentService = async (userId, signal) => {
  return (await axiosInstance.get(`${APIROUTE.sharePercent}/${userId}`, signal)).data; 
}

export const updateSharePercentService = async (payload) => {
  let filteredPayload = {
    "userId" : payload.userId
  }
  return (await axiosInstance.put(`${APIROUTE.sharePercent}/${payload.userId}`, filteredPayload)).data;
};

export const getSharePercentByGameTypeService = async (payload, gameTyeId) => {

  return (await axiosInstance.get(`${APIROUTE.getSharePercentByGameType}/${ gameTyeId }`, payload)).data;
};

export const createOrUpdateShareForAGameType = async(payload, gameTypeId) => {

  return (await axiosInstance.post(`${APIROUTE.sharePercent}/create-update/${ gameTypeId }`, payload)).data;

}

